import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";

function Image(props){

  return (
      <div className="Image" onClick={props.selection.toggleActive}>
          <img src={props.selection.img} />

          {props.selection.active && <div className="active remove" />}
          {!props.selection.active && <div className="active add" />}
      </div>
  );
}

export default observer(Image);
